// @flow
import ContrastColorUpdater from "../../helper/ContrastColorUpdater";
import useThemeStylesheet from "../../hooks/useThemeStylesheet";

const FordTheme = props => {
	useThemeStylesheet(() => import("./ford.lazy.scss"));
	return <>
		<ContrastColorUpdater/>
		{props.children}
	</>;
};

export default FordTheme;
